var map = {
	".": "X9kl",
	"./": "X9kl",
	"./2023-06-03": "jVl+",
	"./2023-06-03.json": "jVl+",
	"./2023-07-29": "MfXY",
	"./2023-07-29.json": "MfXY",
	"./2023-08-03": "9HpD",
	"./2023-08-03.json": "9HpD",
	"./2023-08-11": "pV/D",
	"./2023-08-11.json": "pV/D",
	"./2023-08-23": "bKtD",
	"./2023-08-23.json": "bKtD",
	"./2023-09-18": "a/u1",
	"./2023-09-18.json": "a/u1",
	"./2023-10-12": "DJaF",
	"./2023-10-12.json": "DJaF",
	"./2023-11-10": "bGx6",
	"./2023-11-10.json": "bGx6",
	"./2023-11-22": "axDH",
	"./2023-11-22.json": "axDH",
	"./2023-12-08": "+29D",
	"./2023-12-08.json": "+29D",
	"./2023-12-21": "CpXJ",
	"./2023-12-21.json": "CpXJ",
	"./2024-01-10": "KYMz",
	"./2024-01-10.json": "KYMz",
	"./2024-01-23": "G8cI",
	"./2024-01-23.json": "G8cI",
	"./2024-02-04": "NFKy",
	"./2024-02-04.json": "NFKy",
	"./2024-02-23": "NuRj",
	"./2024-02-23.json": "NuRj",
	"./2024-03-04": "3c71",
	"./2024-03-04.json": "3c71",
	"./2024-03-14": "Jip9",
	"./2024-03-14.json": "Jip9",
	"./2024-03-19": "j7dp",
	"./2024-03-19.json": "j7dp",
	"./2024-03-28": "ZNZv",
	"./2024-03-28.json": "ZNZv",
	"./2024-04-15": "i/xj",
	"./2024-04-15.json": "i/xj",
	"./2024-04-25": "87c6",
	"./2024-04-25.json": "87c6",
	"./2024-05-23": "KSJz",
	"./2024-05-23.json": "KSJz",
	"./2024-05-27": "5LYy",
	"./2024-05-27.json": "5LYy",
	"./2024-06-13": "vBmL",
	"./2024-06-13.json": "vBmL",
	"./2024-06-28": "khDw",
	"./2024-06-28.json": "khDw",
	"./2024-07-11": "vGFC",
	"./2024-07-11.json": "vGFC",
	"./2024-07-22": "/chU",
	"./2024-07-22.json": "/chU",
	"./2024-07-30": "l7kI",
	"./2024-07-30.json": "l7kI",
	"./2024-08-08": "F1dE",
	"./2024-08-08.json": "F1dE",
	"./2024-08-17": "aG00",
	"./2024-08-17.json": "aG00",
	"./2024-08-22": "L5DY",
	"./2024-08-22.json": "L5DY",
	"./2024-08-27": "TvGs",
	"./2024-08-27.json": "TvGs",
	"./2024-09-11": "EMrv",
	"./2024-09-11.json": "EMrv",
	"./2024-09-23": "nNlN",
	"./2024-09-23.json": "nNlN",
	"./2024-10-09": "zB9+",
	"./2024-10-09.json": "zB9+",
	"./2024-10-11": "ss+C",
	"./2024-10-11.json": "ss+C",
	"./2024-10-16": "UDLl",
	"./2024-10-16.json": "UDLl",
	"./2024-10-23": "nC6P",
	"./2024-10-23.json": "nC6P",
	"./2024-10-24": "Aw6+",
	"./2024-10-24.json": "Aw6+",
	"./2024-10-30": "J9sz",
	"./2024-10-30.json": "J9sz",
	"./2024-11-07": "R99K",
	"./2024-11-07.json": "R99K",
	"./2024-11-08": "htuQ",
	"./2024-11-08.json": "htuQ",
	"./2024-11-15": "aAh/",
	"./2024-11-15.json": "aAh/",
	"./2024-11-19": "wh3A",
	"./2024-11-19.json": "wh3A",
	"./2024-12-06": "JseK",
	"./2024-12-06.json": "JseK",
	"./2024-12-17": "bLnD",
	"./2024-12-17.json": "bLnD",
	"./2025-01-21": "GWmm",
	"./2025-01-21.json": "GWmm",
	"./2025-01-22": "g2de",
	"./2025-01-22.json": "g2de",
	"./2025-02-10": "lKCo",
	"./2025-02-10.json": "lKCo",
	"./2025-03-13": "j73g",
	"./2025-03-13.json": "j73g",
	"./2025-04-25": "CBF0",
	"./2025-04-25.json": "CBF0",
	"./2025-05-14": "G4iE",
	"./2025-05-14.json": "G4iE",
	"./2025-06-12": "BVW9",
	"./2025-06-12.json": "BVW9",
	"./2025-06-17": "yMtp",
	"./2025-06-17.json": "yMtp",
	"./2025-06-30": "qi3T",
	"./2025-06-30.json": "qi3T",
	"./2025-07-09": "k7fq",
	"./2025-07-09.json": "k7fq",
	"./2025-07-11": "Di8Z",
	"./2025-07-11.json": "Di8Z",
	"./2025-08-21": "ZXEx",
	"./2025-08-21.json": "ZXEx",
	"./2025-09-01": "w96y",
	"./2025-09-01.json": "w96y",
	"./2025-09-10": "erks",
	"./2025-09-10.json": "erks",
	"./2025-10-09": "8erW",
	"./2025-10-09.json": "8erW",
	"./2025-10-11": "uWtu",
	"./2025-10-11.json": "uWtu",
	"./2025-11-13": "xZQU",
	"./2025-11-13.json": "xZQU",
	"./2025-11-25": "h/Yp",
	"./2025-11-25.json": "h/Yp",
	"./2025-12-09": "1/6l",
	"./2025-12-09.json": "1/6l",
	"./2025-12-16": "fgRV",
	"./2025-12-16.json": "fgRV",
	"./2025-12-18": "4myO",
	"./2025-12-18.json": "4myO",
	"./2026-01-05": "xvYq",
	"./2026-01-05.json": "xvYq",
	"./2026-01-22": "Bn4Z",
	"./2026-01-22.json": "Bn4Z",
	"./index": "X9kl",
	"./index.js": "X9kl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PWE0";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog ^.*$
// module id = PWE0
// module chunks = 3